// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/packaging-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produktePackaging2EN: PageEntry = {
  id: "example.en-produkte-packaging-2",
  locale: "en",
  slug: "produkte/packaging-2",
  seo: {
    title: "Packaging 2 | Dietz GmbH",
    description: "Packaging 2",
  },
  type: "post",
  h1: "Packaging 2",
  intro: "Packaging 2",
  blocks: [
    { kind: "image", src: "/images/live/verpackung-image002.png", alt: "Packaging 2", width: 600, height: 440 }
  ],
};
